/* Removes only near-white pixels connected to an outer edge. No external upload. */
(() => {
  function removeWhite(data, width, height) {
    const count = width * height;
    if (data.length !== count * 4) throw new Error('Ongeldige afbeelding.');
    const seen = new Uint8Array(count), queue = new Uint32Array(count);
    let read = 0, end = 0, removed = 0;
    const eligible = i => {
      const p = i * 4, r = data[p], g = data[p + 1], b = data[p + 2];
      return data[p + 3] < 16 || (Math.min(r,g,b) >= 220 && Math.max(r,g,b) - Math.min(r,g,b) <= 32);
    };
    function add(i) { if (!seen[i] && eligible(i)) { seen[i] = 1; queue[end++] = i; } }
    for (let x=0;x<width;x++) { add(x); add((height-1)*width+x); }
    for (let y=0;y<height;y++) { add(y*width); add(y*width+width-1); }
    while (read < end) {
      const i=queue[read++], p=i*4, x=i%width;
      if (data[p+3] > 0) removed++;
      data[p+3]=0;
      if (x>0) add(i-1); if (x<width-1) add(i+1);
      if (i>=width) add(i-width); if (i<count-width) add(i+width);
    }
    let remaining=0;
    for (let i=3;i<data.length;i+=4) if (data[i]>0) remaining++;
    return {removed,remaining};
  }
  globalThis.KBRemoveWhite = removeWhite;
  if (typeof module !== 'undefined') module.exports = removeWhite;
})();
